<template>
  <main>

    <b-modal id="modalcheckTr" v-model="formModal" ok-only centered :title="modalTitle">
      <p v-if="formStatus === 'success'" class="lead text-success">
        {{$t('message.ttvs') }}
      </p>
      <p v-else-if="formStatus === 'ratelimit'" class="lead text-warning">
        {{ $t('message.ttvrl') }}
      </p>
      <p v-else-if="formStatus === 'recaptcha_failed'" class="lead text-warning">
      {{ $t('message.ttvrc') }}
        <a href="mailto:customer-support@safetravel.today" class="text-warning font-weight-bold"> customer-support@safetravel.today</a>
      </p>
      <p v-else class="lead text-danger">
        {{$t('message.ttvf') }}
        <a href="mailto:customer-support@safetravel.today" class="text-warning font-weight-bold"> customer-support@safetravel.today</a>
      </p>
    </b-modal>

    <div class="container-fluid px-0">
      <div class="row">
        <div class="col-12">
          <div class="custom_page_header">
              <h2>{{$t('message.sft_contact_wewa')}}</h2>
              <p class="lead">{{$t('message.sft_contact_wewatxt')}}</p>
          </div>
        </div>
      </div>
    
      <!-- Content Row -->
      <div class="row pt-3" id="ContactContainer">
        <!-- Map Column -->
        <div class="col-sm-12">
          <div class="row">
            <div class="col-xl-8 col-lg-7 col-md-6 col-sm-12 mb-4">
              <div class="iframe_loader">
                <b-embed
                  type="iframe"
                  aspect="16by9"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3146.2036091218065!2d23.692272576764108!3d37.94903157194194!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14a1bc42e278fa8f%3A0x3123cc31389c9356!2zzp7Otc69zr_Phs-Ozr3PhM6_z4IgODUsIM6azrHOu867zrnOuM6tzrEgMTc2IDcz!5e0!3m2!1sel!2sgr!4v1779369804647!5m2!1sel!2sgr"
                  allowfullscreen
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></b-embed>
              </div>
            </div>
            <!-- Contact Details Column -->
            <div class="col-xl-4 col-lg-5 col-md-6 col-sm-12">
              <h1 class="mainTitleContact">{{$t('message.sft_contact_details')}}</h1>
              <div class="mt-2">
                <h5 title="Address" class="savetravellocdetails">{{$t('message.sft_contact_address')}}</h5>
                <span class="detsafspan">{{$t('message.sft_contact_ouraddress')}} 85–87, Kallithea 17673, Athens, Greece</span>
              </div>
              <div class="mt-2">
                <h5 title="Phone" class="savetravellocdetails">{{$t('message.sft_contact_phone')}}</h5>
                <span class="detsafspan">(+30) 210 7007135</span>
                <span class="detsafspan d-block">{{$t('message.sft_contact_openhoursdets')}}</span>  
              </div>
              <div class="mt-2">
                <h5 title="Email" class="savetravellocdetails">{{$t('message.sft_contact_mail')}}</h5>
                <a href="mailto:customer-support@safetravel.today">customer-support@safetravel.today</a>
              </div>
              <div class="mt-2">
                <h5 title="Hours" class="savetravellocdetails">{{$t('message.sft_contact_openhours')}}</h5>
                <span class="detsafspan">{{$t('message.sft_contact_openhours_time')}}: 08:00 – 22:00</span> 
              </div>
              <blockquote class="mt-2">
                <p class="mb-0 detsafspan">📌 {{$t('message.sft_contact_smthurgent')}}</p>
                <footer class="blockquote-footer">{{$t('message.sft_contact_team')}}</footer>
              </blockquote>
            </div>
          </div>
        </div>
        <!-- Complaints Process -->
        <div class="col-12">
          <h2 class="savetravellocdetails">🛠 {{$t('message.complains_process')}}</h2>
          <p class="detsafspan">{{$t('message.dissatisfied_process')}}</p>
          <p class="detsafspan">{{$t('message.process_stepone')}}</p>
          <p class="detsafspan">{{$t('message.process_steptwo')}}</p>
          <span class="savetravellocdetails">HealthWatch S.A. – {{$t('message.complaints_handling')}}</span>
          <span class="detsafspan d-block">📧 <a href="mailto:info@healthwatch.gr">info@healthwatch.gr</a></span>
          <span class="detsafspan d-block">📞 +30 2313 084 500</span>
          <span class="detsafspan d-block">🕘 {{$t('message.sft_contact_openhours_time')}}, 09:00 – 17:00 EET</span>
          <p class="detsafspan">{{$t('message.act_indep')}}</p>
          <!-- General Enquiries (Safetravel.today) -->
          <span class="savetravellocdetails">{{$t('message.general_inquiries')}} (Safetravel.today)</span>
          <span class="detsafspan d-block">📧 <a href="mailto:customer-support@safetravel.today">customer-support@safetravel.today</a></span>
          <span class="detsafspan d-block">📞 +30 210 7007135</span>
          <span class="detsafspan d-block">🕘 {{$t('message.sft_contact_openhours_time')}}, 08:00 – 22:00 ({{$t('message.gr_bank_hol')}})</span>
          <p class="detsafspan mt-25">{{$t('message.unrelated_claim')}}</p>
        </div>

        <div class="col-sm-12 pt-1">
          <div class="row justify-content-center align-items-center">
            <div class="col-lg-3 col-md-5 col-sm-5">
              <img class="img-fluid" alt="support logo" :src="support_logo">
            </div>
            <div class="col-lg-9 col-md-7 col-sm-7">
              <h3 class="mainTitleContact">{{$t('message.sft_contact_emergassist')}}</h3>
              <!-- HealthWatch  -->
              <span class="savetravellocdetails">HealthWatch – {{$t('message.emrg_medi_as')}} (TPA)</span>
              <span class="detsafspan d-block">📞 {{$t('message.helpline')}}: +30 2313 084500</span>
              <span class="detsafspan d-block">📧 <a href="mailto:info@healthwatch.gr">info@healthwatch.gr</a></span>
              <p class="detsafspan mt-25">{{$t('message.our_emergency')}}</p>
              <!-- Non-Emergency Claims Support -->
              <span class="savetravellocdetails">{{$t('message.non_emergc')}}</span>
              <p class="detsafspan mb-25">{{$t('message.not_urgent_st')}}</p>
              <span class="detsafspan d-block">📞 {{$t('message.claim_ss_line')}} (HealthWatch): +30 2313 084500</span>
              <span class="detsafspan d-block">📧 <a href="mailto:info@healthwatch.gr">info@healthwatch.gr</a></span>
              <span class="detsafspan d-block">🕘 {{$t('message.avamf')}}, 09:00 – 17:00 EET ({{$t('message.gr_bank_hol')}})</span>
            </div>
          </div>
          <div class="row pt-3">
            <div class="col-12 text-center">
              <h3 class="savetravellocdetails">{{$t('message.sft_contact_ifcontus')}}</h3>
              <h6 class="detsafspan">{{$t('message.sft_contact_ifcontusoon')}}</h6>
            </div>
          </div>
        </div>
        <div class="col-sm-12 mt-1">
          <!-- Contact Form -->
          <div class="row justify-content-center">
            <div class="col-xl-6 col-lg-8 col-md-10 col-sm-12 mb-4">
              <form @submit.prevent="submit">
                <div class="control-group form-group">
                  <div class="controls">
                    <label>{{$t('message.sft_contact_fullname')}}</label>
                    <input type="text" class="form-control" name="name" v-model="formData.name" minlength="4" required :placeholder='$t(`message.sft_contact_placehoname`)'>
                    <p class="help-block"></p>
                  </div>
                </div>
                <div class="control-group form-group">
                  <div class="controls">
                    <label>{{$t('message.sft_contact_phone')}}</label>
                    <input type="tel" class="form-control" name="phone" v-model="formData.phone" pattern=".{6,}" required :placeholder='$t(`message.sft_contact_placehophone`)' onkeyup="this.value=this.value.replace(/([^+0-9]+)/gi, '')">
                  </div>
                </div>
                <div class="control-group form-group">
                  <div class="controls">
                    <label>{{$t('message.sft_contact_mail')}}</label>
                    <input type="email" class="form-control" name="email" v-model="formData.email" minlength="10" required :placeholder='$t(`message.sft_contact_placehomail`)'>
                  </div>
                </div>
                <div class="control-group form-group">
                  <div class="controls">
                    <label>{{$t('message.sft_contact_message')}}</label>
                    <textarea rows="10" cols="100" class="form-control" name="message" v-model="formData.message" minlength="6" required :placeholder='$t(`message.sft_contact_placehomess`)' maxlength="999" style="resize:none"></textarea>
                  </div>
                </div>
                <button type="submit" id="submit" class="btn btn-secondary" :disabled="isSubmitting">{{$t('message.sft_contact_sentmessage')}}</button>
                <small class="text-secondary d-block mt-2">
                  This site is protected by reCAPTCHA and the Google
                  <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and
                  <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.
                </small>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import {
  BEmbed, BModal
} from 'bootstrap-vue'
import { formSubmitMixin } from '@/products';
export default {
  mixins: [formSubmitMixin],
  components: {
    BEmbed,
    BModal
  },
  data() {
    return {
      support_logo: require('@/assets/images/quotation/support2.png'),
      formData: {
        name: '',
        phone:'',
        email:'',
        message:'',
      }
    }
  },
  methods: {
    submit() { this.submitForm('contact') }
  },
}
</script>
<style scoped>
.iframe_loader {
  background:url('../../assets/images/logo/animated_logo.svg') center center no-repeat;
}
</style>